.home {
  max-width: 1160px;
  margin: 0 auto;
  padding: 32px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.greeting {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;
  animation: fade-up 0.6s var(--kh-ease-out) both;
  gap: 24px;
}

.greetingText {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.greetingText h1 {
  font-size: clamp(28px, 3.5vw, 44px);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #ffffff;
  line-height: 1;
}

.greetingClock {
  text-align: right;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  animation: fade-in 0.8s var(--kh-ease-out) 0.2s both;
}

.clockTime {
  font-family: var(--kh-font-mono);
  font-size: clamp(22px, 2.6vw, 34px);
  font-weight: 300;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.clockDate {
  font-family: var(--kh-font-mono);
  font-size: 10px;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
}

/* Sections */

.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: fade-up 0.55s var(--kh-ease-out) 0.15s both;
}

.sectionHeader {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sectionLabel {
  font-family: var(--kh-font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #ffffff;
  text-transform: uppercase;
  flex-shrink: 0;
}

.sectionHeader::after {
  content: "";
  flex: 1;
  height: 0.5px;
  background: rgba(255, 255, 255, 0.2);
}

.sectionCount {
  font-family: var(--kh-font-mono);
  font-size: 10px;
  font-weight: 600;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.15);
  border-radius: var(--kh-radius-badge);
  padding: 2px 7px;
  flex-shrink: 0;
}

/* Apps grid */

.appsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
}

.appCard {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  text-decoration: none;
  color: #ffffff;
  min-height: 84px;
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
  transition:
    background var(--kh-duration-fast) var(--kh-ease-out),
    border-color var(--kh-duration-fast) var(--kh-ease-out),
    transform var(--kh-duration-fast) var(--kh-ease-out);
}

.appCard:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.22);
  transform: translateY(-1px);
}

.appCardIcon {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 2px;
}

.appCardBody {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.appCardName {
  font-size: var(--kh-size-card-name);
  font-weight: 600;
  line-height: 1.2;
}

.appCardDesc {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.35;
}

/* Responsive */

@media (max-width: 700px) {
  .greeting {
    flex-direction: column;
    align-items: flex-start;
  }

  .greetingClock {
    align-items: flex-start;
    text-align: left;
  }

  .appsGrid {
    grid-template-columns: 1fr;
  }
}
